import { type BankruptcyFields } from '@resurs-internal/deposits-app-components';

import { validations } from '@/assets';
import { validationError, validationMessage } from '@/helpers';
import { type BankruptcyDetails } from '@/types/consumer-deposit-application-service';

import { type InitialApplication } from './useApplication';

export const bankruptcy = ({
  application,
  country,
  save,
}: InitialApplication): BankruptcyFields => {
  const {
    bankruptcyTrustee,
    bankruptcyTrusteeContactInformation,
    declaredBankruptcy,
  } = application.bankruptcyDetails || {};

  const productType = application.interestType || undefined;

  const saveBankruptcy = async (bankruptcyDetails: BankruptcyDetails) => {
    return save({ bankruptcyDetails });
  };

  const validateBankruptcy = (hasBankruptcy: boolean | undefined): string =>
    hasBankruptcy === undefined ? 'component.empty' : '';

  const validateName = (trusteeName: string) =>
    validationMessage(
      true,
      validations[country].trusteeName,
      validationError(validations[country].trusteeName, trusteeName),
    );

  const validatePhone = (trusteePhone: string) =>
    validationMessage(
      true,
      validations[country].trusteePhone,
      validationError(validations[country].trusteePhone, trusteePhone),
    );

  return {
    initialBankruptcy: declaredBankruptcy,
    initialName: bankruptcyTrustee,
    initialPhone: bankruptcyTrusteeContactInformation,
    productType,
    saveBankruptcy,
    validateBankruptcy,
    validateName,
    validatePhone,
  };
};
